import { computed } from 'vue'

import { MessageType } from '@protos/chat/message_type_pb'

import i18n from '@vc/i18n'

export const useSystemMessage = (messageType: MessageType) => {
  const tacMessageTypes = [MessageType.TAC_ACCEPTED, MessageType.TAC_DECLINED]

  const systemMessageTypes = [
    MessageType.NOTIFICATION,
    MessageType.BOT_NOTIFICATION,
    MessageType.ASSIGNEE_UPDATE_NOTIFICATION,
    MessageType.STATUS_UPDATE_NOTIFICATION,
    ...tacMessageTypes,
  ]

  const isSystemMessage = computed(() =>
    systemMessageTypes.includes(messageType)
  )
  const isTacSystemMessage = computed(() =>
    tacMessageTypes.includes(messageType)
  )

  const tacSystemMessageText = computed(() =>
    messageType === MessageType.TAC_DECLINED
      ? i18n.global.t('vc.tac.banner.declined')
      : i18n.global.t('vc.tac.banner.accepted')
  )

  return {
    systemMessageTypes,
    isSystemMessage,
    isTacSystemMessage,
    tacSystemMessageText,
  }
}
